import type { PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';

export const FirmsBrowserRouter = ({ children }: PropsWithChildren) => (
  <BrowserRouter useTransitions={false}>{children}</BrowserRouter>
);
